
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type garageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function garageRT(): TemplateResult<garageRTRootProps> {
    function onClick1() {
        window.Convermax.openVehicleDialog();
    }
    return _createElement('div', { 'className': 'cm_garage' }, _createElement('button', {
        'onClick': onClick1.bind(this),
        'className': 'cm_toggle-dropdown garage-button',
        'title': 'Garage: ' + this.size + ' item(s)',
        'role': 'button'
    }, _createElement('div', { 'className': 'garage-icon-container' }, [_createElement('svg', {
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '24',
            'height': '18',
            'viewBox': '0 0 24 18',
            'fill': 'none',
            'key': '2230'
        }, _createElement('path', {
            'd': 'M11.59 0.00877803C11.6761 -0.00834096 11.7664 0.000381803 11.8488 0.0341687L21.7433 4.09179L22.9738 4.59667C23.2035 4.69106 23.313 4.95379 23.2189 5.18358C23.1245 5.41327 22.8618 5.52382 22.632 5.42968L22.0226 5.1787V17.166C22.0223 17.4142 21.8207 17.6152 21.5724 17.6152C21.3242 17.6151 21.1225 17.4142 21.1222 17.166V4.80956L11.6798 0.936512L2.33609 4.81932V17.166C2.33579 17.4143 2.13422 17.6152 1.8859 17.6152C1.63764 17.6151 1.436 17.4142 1.4357 17.166V5.19335L0.6232 5.53124L0.53531 5.55761C0.330112 5.59716 0.117727 5.48857 0.0343331 5.28807C-0.060718 5.0588 0.0484133 4.79566 0.277497 4.70018L1.71304 4.1035L11.505 0.0341687L11.59 0.00877803ZM18.714 6.30468C19.2386 6.30471 19.6642 6.73025 19.6642 7.25487V17.1621C19.6642 17.4106 19.4625 17.6123 19.214 17.6123H4.14176C3.89323 17.6123 3.69156 17.4106 3.69156 17.1621V7.25487C3.6916 6.73023 4.11711 6.30468 4.64176 6.30468H18.714ZM4.59195 16.7119H18.7638V14.2305H4.59195V16.7119ZM4.59195 13.3301H18.7638V10.6406H4.59195V13.3301ZM4.64176 7.20507C4.61416 7.20507 4.59199 7.22729 4.59195 7.25487V9.74022H18.7638V7.25487C18.7638 7.22731 18.7416 7.2051 18.714 7.20507H4.64176Z',
            'fill': 'CurrentColor'
        }))], this.size ? _createElement('span', {
        'className': 'garage-size',
        'key': '1515'
    }, this.size) : null), _createElement('span', { 'className': 'garage-label' }, _translate(`garage_title`))));
}
        export const componentNames = []